import BaseService from "./geral/BaseService";

const base = "Notices";

export default class NoticesServices extends BaseService {
    constructor() {
        super(base)
    }

    get = () => {
        return this.httpGet(`${base}`)
    }

    getById = (id) => {
        return this.httpGet(`${base}?id=${id}`)
    }

    getHome = () => {
        return this.httpGet(`Home/Notices`)
    }

    getBarraNotificacoes = () => {
        return this.httpGet(`Home/NoticesNotificacoes`)
    }

    addOrEdit = (model) => {
        return this.httpPost(`${base}`, model)
    }
}


// WEBPACK FOOTER //
// ./src/services/NoticesService.js